import { useEffect } from 'react';
import type { IndexOrderTextData, TextData } from '../dto/EntityRepository';
import { useEditMode } from './useEditMode';
import { useTextIndexStore } from '../store/TextIndexStore';

export interface UseTextIndexingResult {
  isIndexingMode: boolean;
  /** 인덱싱 순서 패널에 미저장 변경 여부 */
  isChanged: boolean;
  setIsIndexingMode: (enabled: boolean) => void;
  selectedIndexingTextList: IndexOrderTextData[];
  addSelectedIndexingText: (text: TextData) => void;
  mergeIndexingDropAtSlot: (draggedIds: string[], dropIndex: number) => void;
  removeSelectedIndexingText: (id: string) => void;
  clearSelectedIndexingTextList: () => void;
  clearTextIndexingChangedFlag: () => void;
}

/**
 * Text 인덱싱 스토어 구독 + 편집 모드 종료 시 선택 목록 비움.
 */
export function useTextIndexing(): UseTextIndexingResult {
  const { isEditMode } = useEditMode();
  const isIndexingMode = useTextIndexStore((s) => s.isIndexingMode);
  const isChanged = useTextIndexStore((s) => s.isChanged);
  const setIsIndexingMode = useTextIndexStore((s) => s.setIsIndexingMode);
  const selectedIndexingTextList = useTextIndexStore((s) => s.selectedIndexingTextList);
  const addSelectedIndexingText = useTextIndexStore((s) => s.addSelectedIndexingText);
  const mergeIndexingDropAtSlot = useTextIndexStore((s) => s.mergeIndexingDropAtSlot);
  const removeSelectedIndexingText = useTextIndexStore((s) => s.removeSelectedIndexingText);
  const clearSelectedIndexingTextList = useTextIndexStore((s) => s.clearSelectedIndexingTextList);
  const clearTextIndexingChangedFlag = useTextIndexStore((s) => s.clearTextIndexingChangedFlag);

  useEffect(() => {
    if (!isEditMode) clearSelectedIndexingTextList();
  }, [isEditMode]);

  return {
    isIndexingMode,
    isChanged,
    setIsIndexingMode,
    selectedIndexingTextList,
    addSelectedIndexingText,
    mergeIndexingDropAtSlot,
    removeSelectedIndexingText,
    clearSelectedIndexingTextList,
    clearTextIndexingChangedFlag,
  };
}
